var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        {
          attrs: { color: "primary", dark: "", tabs: "", flat: "", dense: "" },
        },
        [
          _c("v-app-bar-nav-icon", {
            on: {
              click: function ($event) {
                return _vm.$emit("toggle-drawer")
              },
            },
          }),
          _vm.pages
            ? _c(
                "v-tabs",
                {
                  attrs: {
                    "background-color": "primary",
                    grow: "",
                    "show-arrows": "",
                  },
                  model: {
                    value: _vm.tabRef,
                    callback: function ($$v) {
                      _vm.tabRef = $$v
                    },
                    expression: "tabRef",
                  },
                },
                [
                  _c("v-tabs-slider", { attrs: { color: "accent" } }),
                  _vm._l(_vm.pages, function (page) {
                    return _c("v-tab", { key: page.title }, [
                      _vm._v(_vm._s(page.title)),
                    ])
                  }),
                ],
                2
              )
            : _vm._e(),
          _c("v-spacer"),
          _c(
            "v-menu",
            {
              attrs: { "offset-y": "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var menuOn = ref.on
                    return [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var tooltipOn = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            icon: "",
                                            disabled: _vm.loadPending,
                                          },
                                        },
                                        Object.assign({}, menuOn, tooltipOn)
                                      ),
                                      [_c("v-icon", [_vm._v("mdi-download")])],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [_c("span", [_vm._v("Download Outputs")])]
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "v-list",
                { attrs: { dense: "" } },
                _vm._l(_vm.downloadMenu, function (item) {
                  return _c(
                    "v-list-item",
                    {
                      key: item.text,
                      attrs: { dense: "" },
                      on: { click: item.action },
                    },
                    [
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v(_vm._s(item.text))])],
                        1
                      ),
                      _c(
                        "v-list-item-action",
                        [
                          _c("v-list-item-action-text", [
                            _vm._v(_vm._s(item.extension)),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.loadPending
        ? _c(
            "v-expand-transition",
            [
              _c(
                "v-dialog",
                {
                  attrs: {
                    value: _vm.loadPending,
                    "hide-overlay": "",
                    persistent: "",
                    width: "300",
                  },
                },
                [
                  _c(
                    "v-card",
                    { attrs: { color: "primary", dark: "" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _vm._v(" Loading... "),
                          _c("v-progress-linear", {
                            attrs: { indeterminate: "", color: "white" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.pages
        ? _c(
            "v-tabs-items",
            {
              model: {
                value: _vm.tabRef,
                callback: function ($$v) {
                  _vm.tabRef = $$v
                },
                expression: "tabRef",
              },
            },
            _vm._l(_vm.pages, function (page) {
              return _c(
                "v-tab-item",
                { key: page.title },
                [
                  page.component
                    ? _c(
                        page.component,
                        _vm._b(
                          {
                            ref:
                              page.title === "Power Flow"
                                ? "powerFlowDashboard"
                                : undefined,
                            refInFor: true,
                            tag: "component",
                          },
                          "component",
                          page.props,
                          false
                        )
                      )
                    : _vm._e(),
                  _vm._l(page.sections, function (section) {
                    return _c(
                      "CardSimple",
                      _vm._b(
                        { key: section.title, attrs: { title: section.title } },
                        "CardSimple",
                        section.cardProps,
                        false
                      ),
                      [
                        section.tabs
                          ? _c(
                              "v-tabs",
                              [
                                _vm._l(section.tabs, function (tab) {
                                  return [
                                    _c(
                                      "v-tab",
                                      {
                                        key: tab.name,
                                        attrs: {
                                          href:
                                            "#" +
                                            _vm.$utils.kebabCase(
                                              page.title +
                                                section.title +
                                                tab.name
                                            ),
                                        },
                                      },
                                      [_vm._v(_vm._s(tab.name))]
                                    ),
                                    _c(
                                      "v-tab-item",
                                      {
                                        key: tab.name,
                                        attrs: {
                                          value: _vm.$utils.kebabCase(
                                            page.title +
                                              section.title +
                                              tab.name
                                          ),
                                          lazy: "",
                                        },
                                      },
                                      [
                                        _c("OutputSection", {
                                          attrs: { section: section },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                }),
                              ],
                              2
                            )
                          : _c("OutputSection", {
                              attrs: { section: section, panel: section.panel },
                            }),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            }),
            1
          )
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          attrs: {
            app: "",
            bottom: "",
            right: "",
            text: "",
            color: "primary",
            timeout: -1,
          },
          model: {
            value: _vm.npcDowloadProgress.value,
            callback: function ($$v) {
              _vm.$set(_vm.npcDowloadProgress, "value", $$v)
            },
            expression: "npcDowloadProgress.value",
          },
        },
        [_c("div", [_vm._v(_vm._s(_vm.npcDowloadProgress.text))])]
      ),
      _vm.isNPCSqlOutput
        ? _c("NPCTimeseriesDownload", {
            attrs: {
              "current-case": _vm.currentCase,
              "parquet-files": _vm.npcParquetFiles,
              "yearly-output": _vm.npcOutput,
            },
            model: {
              value: _vm.npcTimeseriesDialog,
              callback: function ($$v) {
                _vm.npcTimeseriesDialog = $$v
              },
              expression: "npcTimeseriesDialog",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }